import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransferLeadRoutingModule } from './transfer-lead-routing.module';
import { TransferLeadComponent } from './transfer-lead.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from '../shared.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [
    TransferLeadComponent,
  ],
  imports: [
    CommonModule,
    TransferLeadRoutingModule,
    SharedModule,
    MatIconModule,
    MatProgressBarModule,
    NgxMatSelectSearchModule,
  ]
})
export class TransferLeadModule { }
